import { type ThemeOptions } from '@mui/material/styles';

export const templateCustomizations: ThemeOptions = {
  template: {
    content: {
      px: { xl: 7.5, lg: 5, sm: 2, xs: 1 },
      py: { xl: 6, lg: 5, xs: 3 },
    },
  },
};
